import { Product } from '@mwe/models';
import { isProductCategory } from '@mwe/utils';
import { ProductCategoryEnum } from '@mwe/constants';

export const checkIfRelocationIsAllowed = (products: Product[]): boolean => {
  if (!Array.isArray(products) || products.length <= 1) {
    return true;
  }

  const stromGasArray = products.filter(
    product =>
      isProductCategory(product.category, ProductCategoryEnum.STROM) || isProductCategory(product.category, ProductCategoryEnum.GAS),
  );

  const fernwaermeArray = products.filter(product => isProductCategory(product.category, ProductCategoryEnum.FERNWAERME));

  return isThereOnlyOneUniqueCustomer(stromGasArray) && isThereOnlyOneUniqueCustomer(fernwaermeArray);
};

export const isThereOnlyOneUniqueCustomer = (products: Product[]): boolean => {
  if (!Array.isArray(products) || products.length <= 1) {
    return true;
  }

  const customerNumbers = products.map(product => product.customerNumber);
  const uniqueCustomerNumbers = Array.from(new Set(customerNumbers));
  return uniqueCustomerNumbers.length === 1;
};
